import CallErrorModalView from './callErrorModal.view';

export default CallErrorModalView;
